import apiCheck from 'api-check';
import 'arrive';
import { VERSION } from './current_version';
import TemplateCacheService from './core/template-cache.service';
import { downgradeInjectable } from '@angular/upgrade/static';
import { BroadcastService, OrganisationService } from '@fry-it/risr-core';
import { ReportStore } from '@fry-it/risr-features/reports';
import { FeaturesService } from '@fry-it/risr-core';
import { Router } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { RouterEventsService } from '@fry/upgrade/router.events.service';
import { RouterHelperService } from '@fry/upgrade/router.helper.service';
import { getTemplate, createComponent } from './core/template-helper';
import { preloadTemplates } from './generated/templates';


(function() {
  'use strict';

  function config($locationProvider, pouchDBProvider, POUCHDB_METHODS) {
    $.material.init();

    var authMethods = {};
    pouchDBProvider.methods = angular.extend([], POUCHDB_METHODS, authMethods);
    $locationProvider.html5Mode({ enabled: true, requireBase: false });
  }

  function appRun($log, $rootScope,
    Profile, formlyConfig, FORM_TYPES, $templateCache,
    FORM_WRAPPERS, _ShareService, FrylyticsService, Events,
    BroadcastService, KZ_ENVIRONMENT) {
    $log.debug('Starting app');

    // Templates are now pre-loaded via the generated templates.js file
    // and managed by TemplateCacheService

    preloadTemplates($templateCache);

    BroadcastService.messages$.subscribe(message => {
      $rootScope.$broadcast(message.msg, message.data);
    });

    $rootScope.$on('KZCurrentListChange', function(_evt, args) {
      $log.debug('List changed to:', args.list ? args.list : 'none');
      Events.currentList = args.list;
      Events.currentSearch = args.search;
    });

    // set up the various form elements needed by formly
    formlyConfig.extras.errorExistsAndShouldBeVisibleExpression = 'fc.$touched || form.$submitted';

    apiCheck.globalConfig.disabled = true;
    formlyConfig.disableWarnings = true;
    if (KZ_ENVIRONMENT !== 'local') {
      if (window.apiCheck !== undefined) {
        window.apiCheck.globalConfig.disabled = true;
      }

      formlyConfig.disableWarnings = true;
    }

    _.forEach(FORM_WRAPPERS, function(wrapper) {
      formlyConfig.setWrapper(wrapper);
    });
    _.forEach(FORM_TYPES, function(type) {
      formlyConfig.setType(type);
    });

    $rootScope.$on('KZPreferencesChange', function() {
      Profile.savePreferences();
    });
    $log.debug('Finished setup app');
    $log.debug('Frylytics INIT');
    FrylyticsService.init();
    $log.debug('/Frylytics INIT');
  }

  config.$inject = ['$locationProvider', 'pouchDBProvider', 'POUCHDB_METHODS'];
  appRun.$inject = [
    '$log', '$rootScope',
    'ProfileService', 'formlyConfig', 'FORM_TYPES', '$templateCache', 'FORM_WRAPPERS',
    'ShareService', 'FrylyticsService', 'EventsService',
    'BroadcastService', 'KZ_ENVIRONMENT'];

  angular.module('epf',
    [

      // Core
      'epf.core',

      // Layout
      'epf.layout',

      // Blocks
      'epf.blocks',

      // Components
      'epf.component'

    ]
  );

  angular.module('epf.core')
    .constant('KZ_ENVIRONMENT', 'local')
    .constant('KZ_CONFIG', {})
    .constant('PACKAGE_VERSIONS', VERSION);

  // Register the TemplateCacheService as a factory since it's a class
  angular.module('epf.core')
    .factory('TemplateCacheService', ['$templateCache', '$log', ($templateCache, $log) => {
      return new TemplateCacheService($templateCache, $log);
    }])
    // Register helper functions
    .value('getTemplate', getTemplate)
    .value('createComponent', createComponent);

  angular.module('epf')
    .config(config)
    .service('BroadcastService', downgradeInjectable(BroadcastService))
    .service('FeaturesService', downgradeInjectable(FeaturesService))
    .service('OrganisationService', downgradeInjectable(OrganisationService))
    .service('Router', downgradeInjectable(Router))
    .service('RouterHelperService', downgradeInjectable(RouterHelperService))
    .service('LocationStrategy', downgradeInjectable(LocationStrategy))
    .service('RouterEventsService', downgradeInjectable(RouterEventsService))
    .service('ReportStore', downgradeInjectable(ReportStore))
    .run(appRun);

  window.runKaizen = function() {
    angular.bootstrap(document, ['epf'], { strictDi: true });
  };
})();

export default 'epf';
